export const setContracts = (contracts) => {
    return {
        type: 'SET_CONTRACTS',
        contracts
    }
}

export const setContractsLoadedRequest = (loaded) => {
    return {
        type: 'CONTRACTS_LOADED',
        loaded
    }
}

export const selectContract = (contract) => {
    return {
        type: 'SELECT_CONTRACT',
        contract
    }
}

export const newContract = (created) => {
    return {
        type: 'NEW_CONTRACT',
        created
    }
}

export const currentContractUpdated = (updated) => {
    return {
        type: 'CURRENT_CONTRACT_UPDATED',
        updated
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/ContractsActions.js